/**
 * Client helper: submit a bug/feature report via /api/report-issue.
 */

import { getSupabaseClient, hasSupabaseConfig } from '../lib/supabaseClient';

export async function submitIssueReport({ organizationId, description, context = {} }) {
  let token = null;
  if (hasSupabaseConfig()) {
    const supabase = getSupabaseClient();
    const { data } = await supabase.auth.getSession();
    token = data.session?.access_token || null;
  }

  const res = await fetch('/api/report-issue', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({ organizationId, description, context }),
  });

  const json = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(json.error || 'Could not send report');
  }
  return json;
}
